// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2fYGt","footer":"ChangeClinic_footer__1pBy1"};